import { FormWrapperMinimum } from '@ukpostbox/frontend-framework';
import { useFormContext } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import React from 'react';

type RulesetNameType = {
	name: string;
};

function RulesetName(props: RulesetNameType) {
	const { register, getValues, formState } = useFormContext();

	return (
		<FormWrapperMinimum
			invalid={formState.errors[props.name]}
			validationMessage={formState.errors[props.name]?.message as string}
		>
			<input
				type='text'
				className='thing-input'
				placeholder='Name...'
				defaultValue={getValues(props.name)}
				{...register(props.name, { required: 'Name is required' })}
			/>
		</FormWrapperMinimum>
	);
}

export { RulesetName };
